import React from "react"
// import React, { useEffect } from "react"
import "../Course/css/Course.css";
// import { useLocation } from "react-router-dom";
import Resultats from "./sections/Resultats.js";
// import Deplacements from "./sections/Deplacements.js";
// import Programme from "./sections/Programme.js";
// import Animations from "./sections/Animations.js";
// import Recompenses from "./sections/Recompenses.js";
// import Dossards from "./sections/Dossards.js";
// import Inscriptions from "./sections/Inscriptions.js";
// import Services from "./sections/Services.js";
import petitprince from "../Resources/pictogrammes/cdpp-jaune.svg";
import { FaireunDon, col_large, col_small, UseGTMPageView } from "../Fonctions.js";

export default function CourseTerminee() {


  return (
    <div id="Course">
      <FaireunDon />
      <div className="container">
        <div className="row bloc bandeau bleu bandeau-top">
          <div className={`col-xs-12 img ${col_small}`}>
            <img className="img-bandeau" src={petitprince} alt="Petit Prince logo" />
          </div>
          <div className={`col-xs-12 ${col_large}`}>
            <div className="testgrid">
              <h1>La Course Du Petit Prince</h1>
              <h1>Édition du 14 Mai 2026</h1>
            </div>
          </div>
        </div>
      </div>
      
      <Resultats />
      {/* <Services /> */}
      {/* <Animations /> */}
      {/* <Recompenses /> */}
      {/* <UseGTMPageView /> */}
    </div>
  );
}